import * as React from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import { StatusLabel } from '../StatusLabel';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';

export const UnAcknowledgedStatusLabel: React.FC = () => {
    const { t } = useLanguageLocale();
    return (
        <StatusLabel
            status={t('DASHBOARD.TIMELINE_DETAILS.UNACKNOWLEDGED')}
            foregroundColor={PXBColors.blue[600]}
            backgroundColor={PXBColors.blue[50]}
            testId="unacknowledged-status-label"
        />
    );
};
